module.exports = __webpack_public_path__ + "img/CellCycle-CRC_10X_TGSP.9ea2a620.png";